<template>
  <v-container fluid>
    <titleBlock title="Kişi Listesi"
      description="Kişi listeleyebilir, düzenleyebilir lisans bilgilerini değiştirebilirsiniz." />
    <v-card>
      <v-card-title>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Ara" single-line hide-details
          @keyup.enter="getContactData()"></v-text-field>
      </v-card-title>
      <!--table-->
      <v-simple-table id="data_set1">
        <thead>
          <tr>
            <th class="text-left">
              Id
            </th>
            <th class="text-left">
              Firma
            </th>
            <th class="text-left">
              Ad
            </th>
            <th class="text-left">
              Soyad
            </th>
            <th class="text-left">
              Ünvan
            </th>
            <th class="text-left">
              E-posta
            </th>
            <th class="text-left">
              Telefon
            </th>
            <th class="text-left">
              Sil
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in contacts" :key="item.id">
            <td>{{ item.id }}</td>
            <td><span v-if="item.organization">{{ item.organization.name }}</span></td>
            <td><strong @click="openContactAddDialog(item)">{{ item.first_name }}</strong></td>
            <td>{{ item.last_name }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.phone }}</td>
            <td><v-btn class="icon-btn" color="secondary" @click="deleteContactData(item.id)"><span
                  class="mdi mdi-delete-empty"></span></v-btn></td>
          </tr>
        </tbody>
      </v-simple-table>
      <template>
        <div class="text-center">
          <v-pagination v-model="paging.page" @input="getContactData()" :length="paging.pages"></v-pagination>
        </div>
      </template>
      <!--table-->
      <!--dialog-->
      <div class="dialog-area" justify="center">
        <div class="dialog-area-inner">
          <v-dialog v-model="contactAddDialog" persistent width="1024">
            <template v-slot:activator="{ props }">
              <v-btn class="add-btn" color="primary" @click="openContactAddDialog()">
                Ekle +
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">Kişi Ekle</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-combobox name="company" @input.native="newContactData.organizationName = $event.srcElement.value"
                        v-model="newContactData.organization" label="Organizasyon" :items="organizations" item-text="name"
                        item-value="id" @keyup="getOrganizationData()">
                        <template v-slot:item="{ on, item }">
                          <v-list-item v-on="on">
                            {{ item.name }} - (Id: {{ item.id }})
                          </v-list-item>
                        </template>
                        <template v-slot:no-data>
                          <p class="ml-3 mt-3">Organizasyon yok</p>
                        </template>
                      </v-combobox>
                    </v-col>
                  </v-row>
                  <v-row v-if="newContactData.organization">
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Adı*" v-model="newContactData.first_name" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Soyad" v-model="newContactData.last_name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Ünvan" v-model="newContactData.title"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="Telefon" v-model="newContactData.phone"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field label="E-posta*" v-model="newContactData.email" hint="Kişinin e-posta adresi"
                        persistent-hint required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field label="Linkedin" v-model="newContactData.social_linkedin" hint="Kişinin linkedin adresi"
                        persistent-hint required></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <small>*Zorunlu alanlardır</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue-darken-1" variant="text" @click="closeContactAddDialog()">
                  Vazgeç
                </v-btn>
                <v-btn color="primary" variant="text" @click="saveContactAddDialog()">
                  Kaydet
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
      <!--dialog-->
    </v-card>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import titleBlock from "./../../../components/layout/TitleBlock.vue";
import moment from "moment";
export default {
  data() {
    return {
      language: this.$root.localization.data,
      search: null,
      contacts: [],
      contactAddDialog: false,
      paging: {
        limit: 20,
        offset: 0,
        page: 0,
        pages: 1,
        count: 0,
      },
      newContactData: {
        id: null,
        first_name: null,
        last_name: null,
        full_name: null,
        title: null,
        email: null,
        phone: null,
        organizationId: null,
        status: null,
        organization: null,
        organizationName: null,
        social_linkedin:null
      },
      organizations: [],
    };
  },
  methods: {
    ...mapActions({
      getContacts: "admin/getContacts",
      addContact: "admin/addContact",
      deleteContact: "admin/deleteContact",
      saveContact: "admin/saveContact",
      getOrganizations: "admin/getOrganizations",
    }),
    openContactAddDialog(row) {
      let self = this;
      self.contactAddDialog = true;
      if (row) {
        for (let key in row) {
          self.newContactData[key] = row[key];
        }
      }
      else {
        self.clearContactData();
      }
    },
    closeContactAddDialog() {
      this.contactAddDialog = false;
    },
    getContactData() {
      let self = this;
      self.organizations = [];
      this.getContacts({ paging: self.paging, search: self.search }).then(r => {
        for(let row of r.data.records){
          if(row.organization){
            self.organizations.push(row.organization);
          }
        }
        self.paging = r.data.paging;
        self.contacts = r.data.records;
        if(window.queryJson.organizationId){
          self.newContactData.organizationId = window.queryJson.organizationId;
          self.newContactData.organization = self.organizations.find(x=>x.id == self.newContactData.organizationId);
        }
      });
    },
    clearContactData() {
      let self = this;
      self.newContactData.id = null;
      self.newContactData.first_name = null;
      self.newContactData.last_name = null;
      self.newContactData.full_name = null;
      self.newContactData.title = null;
      self.newContactData.email = null;
      self.newContactData.organizationId = null;
      self.newContactData.status = null;
      self.newContactData.organization = null;
      self.newContactData.organizationName = null;
      self.newContactData.phone = null;
      self.newContactData.social_linkedin = null;
    },
    saveContactAddDialog() {
      let self = this;
      self.contactAddDialog = false;
      if (self.newContactData && self.newContactData.id) {
        self.saveContact({
          id: self.newContactData.id,
          first_name: self.newContactData.first_name,
          last_name: self.newContactData.last_name,
          title: self.newContactData.title,
          email: self.newContactData.email,
          organizationId: self.newContactData.organization.id,
          status: self.newContactData.status,
          phone: self.newContactData.phone,
          social_linkedin:self.newContactData.social_linkedin
        }).then((r) => {
          self.getContactData();
          self.$swal.fire(
            "Kaydedildi!",
            "Kişi başarıyla kaydedildi.",
            "success"
          );
          self.clearContactData();
        }).catch((r) => {
          if (r && r.response && r.response.data && r.response.data.message) {
            self.$swal.fire(
              "Kişi kaydedilemedi",
              r.response.data.message,
              "error"
            );
          }
        });
      }
      else {
        self
          .addContact({
            first_name: self.newContactData.first_name,
            last_name: self.newContactData.last_name,
            title: self.newContactData.title,
            email: self.newContactData.email,
            organizationId: self.newContactData.organization.id,
            status: self.newContactData.status,
            phone: self.newContactData.phone,
            social_linkedin:self.newContactData.social_linkedin
          })
          .then((r) => {
            self.getContactData();
            self.$swal.fire(
              "Eklendi!",
              "Kişi başarıyla eklendi.",
              "success"
            );
            self.clearContactData();
          })
          .catch((r) => {
            if (r && r.response && r.response.data && r.response.data.message) {
              self.$swal.fire(
                "Kişi kaydedilemedi",
                r.response.data.message,
                "error"
              );
            }
          });
      }
    },
    deleteContactData(contactId) {
      let self = this;
      self.$swal
        .fire({
          title: "Eminmisiniz?",
          text: "Kişiyi silerseniz bir daha geri getiremezsiniz",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Evet sil!"
        })
        .then(result => {
          if (result.isConfirmed) {
            self.deleteContact({ contactId: contactId }).then(result => {
              self.getContactData();
              self.$swal.fire(
                "Silindi!",
                "Kişi başarıyla silindi.",
                "success"
              );
            });
          }
        });
    },
    getOrganizationData() {
      var self = this;
      if (self.newContactData.organizationName && self.newContactData.organizationName.length > 2) {
        self.getOrganizations({ search: self.newContactData.organizationName }).then(r => {
          self.organizations = r.data.records;
        });
      }
    },
  },
  components: {
    titleBlock
  },
  created() {
    let self = this;
    if(window.queryJson.addNew !== undefined){
      self.openContactAddDialog();
    }
    self.getContactData();
  },
  mounted() { }
};
</script>